/**
 * THIS FILE IS AUTO-GENERATED
 * DON'T MAKE CHANGES HERE
 */
import { typedDependencies } from './dependenciesTyped.generated.js';
import { createSplitUnit } from '../../factoriesAny.js';
export var splitUnitDependencies = {
  typedDependencies,
  createSplitUnit
};


//////////////////
// WEBPACK FOOTER
// ./~/mathjs/lib/esm/entry/dependenciesAny/dependenciesSplitUnit.generated.js
// module id = t9qY
// module chunks = 3